import React, { useCallback, useState, useEffect } from 'react'
import { getMembers, getMembersWF } from 'api/members'
import NoResults from 'components/NoResults'
import SearchBar from 'components/SearchBar'
import Spinner from 'components/Spinner'
import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { MemberData, MemberDataWf } from 'types/member'
import ResultTable from './ResultTable'
import CreateMemberButtons from './Buttons'
import { MemberSearchStateStore } from "store/member-search-state"

import { isQSRHClient, isWFClient } from 'setups/controller'
import { projectClient } from 'constants/project'
const isWF = isWFClient(projectClient)

function MemberLookup(): React.ReactElement {
  const [loading, setLoading] = useState(false)
  const searchArrayString = MemberSearchStateStore(state => state.searchArrayString)
  const searchArrayStringSet = MemberSearchStateStore(state => state.searchArrayStringSet)

  const [postData, setPostData] = useState<(MemberData | MemberDataWf)[] | null>(null)

  const fetchMembers = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (dataArray: any): Promise<void> => {

      if (!dataArray) {
        return
      }

      try {
        const fetchFn = isWF ? getMembersWF : getMembers
        await fetchFn(
          dataArray.fname || dataArray.first_name,
          dataArray.lname || dataArray.last_name,
          dataArray.id || dataArray.trader_id,
          dataArray.card || dataArray.card_number,
          dataArray.email,
          dataArray.phone || dataArray.phone_number
        )
          .then((list) => {
            setPostData(list)
            searchArrayStringSet(JSON.stringify(dataArray))
          })
          .finally(() => {
            setLoading(false)
          })
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        if (message.outcomeUserMessage?.includes("Access Token has expired")) {
          // Handled in http.ts
        } else {
          toast.error(`An unknown error has occured. Please try again`)
        }
      }
    },
    [searchArrayString, searchArrayStringSet]
  )

  useEffect(() => {
    if (searchArrayString) {
      fetchMembers(JSON.parse(searchArrayString))
    }
  }, [fetchMembers, searchArrayString])

  return (
    <div className="p-12 bg-white content-container">
      <div className="flex flex-col lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Members</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Look up for members using member details provided
            </span>
          </p>
          <p className="text-gray-500">
            <span className="tracking-wider font-light text-xs">
              * Use the searchbar to lookup for members information
            </span>
          </p>
          <br />
          {isQSRHClient(projectClient) && (
            <p>
              <CreateMemberButtons />
            </p>
          )}
        </div>

        <div className="w-3/4 lg:w-1/2">
          <SearchBar
            placeholder="Search for member name, id, card ..."
            startFetch={fetchMembers}
            startLoading={() => setLoading(true)}
            stopLoading={() => setLoading(false)}
            closeSearchForm={() => {
              return
            }}
            isMemberLookup
          />
        </div>
      </div>

      <div className="my-6">
        {loading ? (
          <Spinner />
        ) : postData == null ? (
          <></>
        ) : isEmpty(postData) ? (
          <NoResults noImage />
        ) : (
          <ResultTable postData={postData} isWF={isWF as false} />
        )}
      </div>
    </div>
  )
}

export default MemberLookup
